module.exports = __webpack_public_path__ + "img/img6.c923ade9.png";